import { aprobacionesReservasNormalize } from '../Objetos/AprobacionesReservasModel';
import { aprobadoresNormalize } from '../Objetos/AprobadoresModel';
import { archivosAdjuntosNormalize } from '../Objetos/ArchivosAdjuntosModel';
import { catEstadoReservaNormalize } from '../Objetos/CatEstadoReservaModel';
import { catTipoVehiculoNormalize } from '../Objetos/CatTipoVehiculoModel';
import { checklistViajeNormalize } from '../Objetos/ChecklistViajeModel';
import { choferNormalize } from '../Objetos/ChoferModel';
import { choferVehiculoAsignacionNormalize } from '../Objetos/ChoferVehiculoAsignacionModel';
import { diasFestivosInhabiliesNormalize } from '../Objetos/DiasFestivosInhabiliesModel';
import { empleadoTurnoNormalize } from '../Objetos/EmpleadoTurnoModel';
import { excepcionTurnoNormalize } from '../Objetos/ExcepcionTurnoModel';
import { extrasAcumuladoMesNormalize } from '../Objetos/ExtrasAcumuladoMesModel';
import { extrasAcumuladoSemanaNormalize } from '../Objetos/ExtrasAcumuladoSemanaModel';
import { parametrosLaboralesNormalize } from '../Objetos/ParametrosLaboralesModel';
import { reservaNormalize } from '../Objetos/ReservaModel';
import { reservaNotificacionNormalize } from '../Objetos/ReservaNotificacionModel';
import { siniestroNormalize } from '../Objetos/SiniestroModel';
import { solicitantesNormalize } from '../Objetos/SolicitantesModel';
import { solicitanteUnidadesOrganizacionalesNormalize } from '../Objetos/SolicitanteUnidadesOrganizacionalesModel';
import { tipoAprobacionNormalize } from '../Objetos/TipoAprobacionModel';
import { vehiculoNormalize } from '../Objetos/VehiculoModel';
import { vehiculoCombustibleNormalize } from '../Objetos/VehiculoCombustibleModel';
import { vehiculoMantenimientoNormalize } from '../Objetos/VehiculoMantenimientoModel';
import { vehiculoOdometroNormalize } from '../Objetos/VehiculoOdometroModel';

import { empleadosNormalize } from '../Objetos/Foraneos/EmpleadosModel';
import { personasNormalize } from '../Objetos/Foraneos/PersonasModel';
import { eMailNormalize } from '../Objetos/Foraneos/EMailModel';
import { catUnidadesOrgNormalize } from '../Objetos/Foraneos/CatUnidadesOrgModel';
import { unidadesOrgEmpleadoNormalize } from '../Objetos/Foraneos/UnidadesOrgEmpleadoModel';
import { empresasUnidadesOrgNormalize } from '../Objetos/Foraneos/EmpresasUnidadesOrgModel';
import { empresasNormalize } from '../Objetos/Foraneos/EmpresasModel';

import { turnosNormalize } from '../Objetos/Foraneos/TurnosModel';

import { empleadosTurnosNormalize } from '../Objetos/Foraneos/EmpleadosTurnosModel';

export const Models = {
    aprobacionesReservas: (x) => aprobacionesReservasNormalize(x),
    aprobadores: (x) => aprobadoresNormalize(x),
    archivosAdjuntos: (x) => archivosAdjuntosNormalize(x),
    estadoReserva: (x) => catEstadoReservaNormalize(x),
    tipoVehiculo: (x) => catTipoVehiculoNormalize(x),
    checklistViaje: (x) => checklistViajeNormalize(x),
    chofer: (x) => choferNormalize(x),
    choferVehiculoAsignacion: (x) => choferVehiculoAsignacionNormalize(x),
    diasFestivosInhabilies: (x) => diasFestivosInhabiliesNormalize(x),
    empleadoTurno: (x) => empleadoTurnoNormalize(x),
    excepcionTurno: (x) => excepcionTurnoNormalize(x),
    extrasAcumuladoMes: (x) => extrasAcumuladoMesNormalize(x),
    extrasAcumuladoSemana: (x) => extrasAcumuladoSemanaNormalize(x),
    parametrosLaborales: (x) => parametrosLaboralesNormalize(x),
    reserva: (x) => reservaNormalize(x),
    reservaNotificacion: (x) => reservaNotificacionNormalize(x),
    siniestro: (x) => siniestroNormalize(x),
    solicitantes: (x) => solicitantesNormalize(x),
    solicitanteUnidadesOrganizacionales: (x) => solicitanteUnidadesOrganizacionalesNormalize(x),
    tipoAprobacion: (x) => tipoAprobacionNormalize(x),
    vehiculo: (x) => vehiculoNormalize(x),
    vehiculoCombustible: (x) => vehiculoCombustibleNormalize(x),
    vehiculoMantenimiento: (x) => vehiculoMantenimientoNormalize(x),
    vehiculoOdometro: (x) => vehiculoOdometroNormalize(x),

    //General
    empleados: (x) => empleadosNormalize(x),
    persona: (x) => personasNormalize(x),
    correos: (x) => eMailNormalize(x),
    unidadesOrg: (x) => catUnidadesOrgNormalize(x),
    unidadOrgEmpleado: (x) => unidadesOrgEmpleadoNormalize(x),
    empresasUnidadesOrg: (x) => empresasUnidadesOrgNormalize(x),
    empresas: (x) => empresasNormalize(x),

    //RelojChecador
    turnos: (x) => turnosNormalize(x),

    //Seguridad
    empleadosTurnos: (x) => empleadosTurnosNormalize(x),
}
